<hg-base-header>
    <div menuButtonsSlot>
        <hg-button type="cta" icon="taskcheck" [iconPosition]="'left'" [iconColor]="'light'" label="Join Waitlist"></hg-button>
    </div>
</hg-base-header>